import React from 'react'
import { useTranslation } from 'react-i18next'
import { useAppHeaderLoginBtnStyles } from './app-header-login.styles'

export const AppHeaderLoginBtn: React.FC = (): React.ReactElement => {
  const classes = useAppHeaderLoginBtnStyles()
  const {t} = useTranslation()
  return <button className={classes.loginBtn}>
    {t('header.menu.login')}
  </button>
}
